<template>
  <table>
    <thead>
      <tr class="level-one-header">
        <th colspan="10">Advanced Fluid Properties and Contaminants (ppm)</th>
      </tr>
      <tr class="level-two-header">
        <th class="sample-number">Lab ID</th>
        <th>Nitrates</th>
        <th>Phosphate</th>
        <th>Sulfate</th>
        <th>Oxalate</th>
        <th>Acetate</th>
        <th>Formate</th>
        <th>Glycolate</th>
        <th>Fluoride</th>
        <th>Chloride</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(sample, index) in sampleData.coolantSamples" :key="`Secondary Table Sample ${index}`">
        <td>{{ sample.sampleNumber }}</td>
        <td :class="`severity-id-${sample.nitrateSeverity}`">{{ sample.nitrateDisplay }}</td>
        <td :class="`severity-id-${sample.phosphateSeverity}`">{{ sample.phosphateDisplay }}</td>
        <td :class="`severity-id-${sample.sulfateSeverity}`">{{ sample.sulfateDisplay }}</td>
        <td :class="`severity-id-${sample.oxalateSeverity}`">{{ sample.oxalateDisplay }}</td>
        <td :class="`severity-id-${sample.acetateSeverity}`">{{ sample.acetateDisplay }}</td>
        <td :class="`severity-id-${sample.formateSeverity}`">{{ sample.formateDisplay }}</td>
        <td :class="`severity-id-${sample.glycolateSeverity}`">{{ sample.glycolateDisplay }}</td>
        <td :class="`severity-id-${sample.fluorideSeverity}`">{{ sample.fluorideDisplay }}</td>
        <td :class="`severity-id-${sample.chlorideSeverity}`">{{ sample.chlorideDisplay }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'CoolantSampleReportAdvancedFluid',
  props: {
    sampleData: {
      type: Object,
      required: true
    }
  }
};
</script>
